export default "__VITE_ASSET__CcPWgO_q__"